import { useMemo } from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { useInventoryWorkloadsTimeRangeSelection } from '../../../../_hooks/useInventoryWorkloadsTimeRangeSelection';

import { useWorkloadGpuUtilizationSummary } from './useWorkloadGpuUtilizationSummary';

dayjs.extend(utc);

export type GpuWasteChartPoint = {
  timestamp: string;
  chartTimestampUnix: number;
  onDemand: number;
  fallback: number;
  spot: number;
};

export type GpuWasteChartTotals = {
  onDemand: number;
  fallback: number;
  spot: number;
  total: number;
};

export const useGpuWasteChartData = () => {
  const { timeZone } = useInventoryWorkloadsTimeRangeSelection();
  const {
    intervals,
    totals: apiTotals,
    isLoading,
    error,
    refetch,
  } = useWorkloadGpuUtilizationSummary();

  const data: GpuWasteChartPoint[] = useMemo(
    () =>
      intervals
        .filter((item) => item.costImpact)
        .map((item) => ({
          timestamp: item.timestamp,
          chartTimestampUnix: dayjs.utc(item.timestamp).valueOf(),
          onDemand: item.costImpact!.onDemand,
          fallback: item.costImpact!.spotFallback,
          spot: item.costImpact!.spot,
        })),
    [intervals]
  );

  const totals: GpuWasteChartTotals = useMemo(
    () => ({
      onDemand: apiTotals.totalCostImpact?.onDemand ?? 0,
      fallback: apiTotals.totalCostImpact?.spotFallback ?? 0,
      spot: apiTotals.totalCostImpact?.spot ?? 0,
      total: apiTotals.totalCostImpact?.total ?? 0,
    }),
    [apiTotals]
  );

  return {
    data,
    totals,
    isLoading,
    error,
    refetch,
    timeZone,
  };
};
